module.exports = __webpack_public_path__ + "img/2 Feuer im Hof.jpg";